<template>
  <div id="wrapper">
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
      <div class="company_name">
        <div class="header text-center">
          <span class="display_none_xs">
            <img :src="studyData.logoUrl" alt class="logo_image" />
          </span>
        </div>
        <div
          class="client_name display_none_xs text-center pt-2"
          v-if="
            this.user.userRole == 'Pi' ||
              this.user.userRole == 'SubPi' ||
              this.user.userRole == 'HomeHealth' ||
              this.user.userRole == 'StudyCoordinator' ||
              this.user.userRole == 'SiteDataLock' ||
              user.userRole === 'StudyAdmin' ||
              user.userRole === 'SystemAdmin' ||
              user.userRole === 'Quality' ||
              user.userRole === 'Dm' ||
              user.userRole === 'Cra' ||
              user.userRole === 'CraUB' ||
              this.user.userRole === 'StudyManager' ||
              this.user.userRole === 'Biostatistics' ||
              this.user.userRole === 'Pharmacovigilance' ||
              this.user.userRole === 'Interviewer' ||
              this.user.userRole == 'Rater' ||
              this.user.userRole == 'CallCenter' ||
              this.user.userRole == 'Support'
          "
        >
          {{ studyData.name }}
        </div>
        <div v-if="this.user.userRole == 'Pi' || this.user.userRole == 'SubPi' || this.user.userRole == 'HomeHealth' || this.user.userRole == 'StudyCoordinator' || this.user.userRole == 'SiteDataLock' || this.user.userRole == 'Rater' || this.user.userRole == 'CallCenter'">
          <div class="siteId-b0bac9display_none_xs text-center pt-2">Site ID</div>
          <div class="client_name display_none_xs text-center pt-2">{{ userDefineSiteId }}</div>
        </div>
      </div>

      <ul class="sidebar-nav">
        <SideMenuLink class="menu-item" faIcon="fa-tachometer" :to="{ name: 'dashboard', params: { studyId } }" title="Dashboard" />
        <SideMenuLink v-if="analyticsEnabled" class="menu-item" :class="$parent.isEdroDashboard ? 'router-link-active' : ''" faIcon="fa-bar-chart" :to="{ name: 'analytics', params: { studyId } }" title="Analytics" />
        <SideMenuLink class="menu-item" v-if="canSysAdminAccess || canStudyAdminAccess || canQualityAccess || canBioStatisticsAccess || canPharmacovigilanceAccess || canStudyManagerAccess || canSupportAccess" icon="static/img/side-menu-icons/icn-team.svg" activeIcon="static/img/side-menu-icons/icn-team-active.svg" :to="{ name: 'study-admins', params: { studyId } }" title="Research Team" />
        <SideMenuLink
          class="menu-item"
          v-if="canPiAccess || canSubPiAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess || canSiteDataLockAccess || user.readOnly"
          icon="static/img/side-menu-icons/icn-team.svg"
          activeIcon="static/img/side-menu-icons/icn-team-active.svg"
          :to="{ name: 'site-details', params: { studyId: studyId, siteId: selectedSiteId } }"
          title="Site Team"
        />
        <SideMenuLink class="menu-item" icon="static/img/side-menu-icons/icn-participant.svg" activeIcon="static/img/side-menu-icons/icn-participant-active.svg" :to="{ name: 'study-participants-list', params: { studyId } }" title="Participants" />
        <SideMenuLink class="menu-item" v-if="user.userRole !== 'Interviewer' && !canRaterAccess" icon="static/img/side-menu-icons/icn-view-study.svg" activeIcon="static/img/side-menu-icons/icn-view-study-active.svg" :to="{ name: 'study-details', params: { studyId } }" title="Study Details" />
        <SideMenuLink class="menu-item" v-if="studyData.participantPortal && studyData.web === true && (canSysAdminAccess || canStudyAdminAccess)" icon="static/img/participant-web-img/side-menu-icon.png" activeIcon="static/img/participant-web-img/web-icon.png" :to="{ name: 'global', params: { studyId } }" title="Recruitment Web" />

        <SideMenuLink class="menu-item" v-if="canSysAdminAccess || canStudyAdminAccess" icon="/static/img/side-menu-icons/icn-modify.svg" activeIcon="/static/img/side-menu-icons/icn-modify.svg" :to="{ name: 'study-summary', params: { studyId } }" v-on:click.native="modifyStudy()" title="Modify Study" />
        <SideMenuLink class="menu-item" v-if="(canSysAdminAccess || canStudyAdminAccess) && edcEnabled && isShowActivities" faIcon="fa-file-text" :to="{ name: 'forms-list', params: { studyId } }" title="Data capture forms" />
        <SideMenuLink class="menu-item" icon="static/img/side-menu-icons/icn-participant.svg" activeIcon="static/img/side-menu-icons/icn-participant-active.svg" :to="{ name: 'resource-list-site', params: { studyId } }" :count="calResouceCount" :title="resourceValue" />
      </ul>
    </div>

    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import { SYSTEM_ADMIN, STUDY_ADMIN, PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, QUALITY, SITEDATALOCK, BSTAT, PHV, RATER, STUDY_MANAGER, CC, SUPPORT } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import SideMenuLink from "./side-menu-link";
import localStorageService from "@/services/localStorage";

export default {
  name: "SideMenu",
  components: {
    SideMenuLink
  },
  props: {
    studyData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      studyId: this.$route.params.studyId,
      toggleFeatures: {},
      edcEnabled: false,
      analyticsEnabled: false,
      telehealthEnabled: false,
      isTelehealthV2Enabled: false,
      resourceValue: "Resources",
      materialCount: 0,
      newAnnCount: 0,
      newLinksCount: 0,
      newResourceCount: 0,
      gettedmaterialsData: [],
      newLinksData: [],
      newAnnouncementData: [],
      piRoleUniqueId: "",
      userDefineSiteId: "",
      selectedSiteId: "",
      isShowActivities: false,
      zendeskUserObj: {
        isUserExistOnZendesk: false,
        redirectURL: "",
        annoucementCount: 0,
        name: "",
        email: ""
      }
    };
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canView() {
      return this.studyData.truClinicIntegration;
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canTelehealthView() {
      return this.studyData.telehealthIntegration;
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    isTelehealthEnabledForCountry() {
      return (
        this.user.countries &&
        _.chain(this.user.countries)
          .filter({ isTelehealthEnabled: true })
          .size()
          .value() > 0
      );
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    calResouceCount() {
      return this.newResourceCount;
    }
  },
  async created() {
    await this.getParticularPIrole();
    this.getMaterialCount();
  },
  mounted() {
    this.$root.$on("resource_uploaded", data => {
      this.getMaterialCount();
    });
    this.getUserObj();
    this.getFeatures();
    this.$root.$on("toggledfeaturesEmit", data => {
      this.getToggledFeatures();
    });
  },
  methods: {
    getFeatures() {
      this.$api.getLibraryFeaturesFact(this.studyId).then(response => {
        let checkActivities = response.body.studyLibraryFeatures.filter(data => {
          return data.name === "Activities";
        });
        if (checkActivities.length > 0) {
          this.isShowActivities = false;
        } else {
          this.isShowActivities = true;
        }
      });
    },
    ...mapActions(["selectedFeaturesAction", "setStudyToggledFeaturesData"]),
    modifyStudy() {
      window.localStorage.setItem("thread-studySummary", true);
      this.$router.push({
        name: "study-summary",
        params: { studyId: this.studyId }
      });
    },
    getParticularPIrole() {
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "Interviewer" || this.user.userRole == "CallCenter") {
        this.$api.getSiteDetailsFact(this.studyId, this.user.siteIds[0]).then(response => {
          window.localStorage.removeItem("getSiteIdDetails");
          window.localStorage.setItem("getSiteIdDetails", JSON.stringify(response.body));
          this.piRoleUniqueId = response.body.userSiteId;
          return new Promise(resolve => {
            resolve(this.piRoleUniqueId);
          });
        });
      }
    },
    async getMaterialCount() {
      this.newResourceCount = 0;
      this.materialCount = 0;
      this.newAnnCount = 0;
      this.newLinksCount = 0;
      await this.$api.getAllResourcesData(this.studyId, "material").then(response => {
        window.localStorage.removeItem("materialData");
        window.localStorage.setItem("materialData", JSON.stringify(response.body));
        let materialOrderSequence = [];
        if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "Interviewer" || this.user.userRole == "CallCenter") {
          materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          let dataResource = [];
          let dataSitesResource = [];
          let overallListResource = [];
          materialOrderSequence.forEach(elementData => {
            dataResource = elementData;
            dataSitesResource = elementData.studySiteMeta;
            dataSitesResource.forEach(elementList => {
              if (elementList.siteId == this.piRoleUniqueId) {
                overallListResource.push(dataResource);
              }
            });
          });
          materialOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
          this.gettedmaterialsData = materialOrderSequence;
        } else if (this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") {
          let materialData = _.orderBy(response.body, "createdTime", "desc");
          this.gettedmaterialsData = materialData.filter(el => {
            return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
          });
        } else {
          materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          this.gettedmaterialsData = materialOrderSequence;
        }
      });
      await this.$api.getAllResourcesData(this.studyId, "links").then(response => {
        window.localStorage.removeItem("linksData");
        window.localStorage.setItem("linksData", JSON.stringify(response.body));
        let materialOrderSequence = [];
        if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "Interviewer" || this.user.userRole == "CallCenter") {
          materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          let dataResource = [];
          let dataSitesResource = [];
          let overallListResource = [];
          materialOrderSequence.forEach(elementData => {
            dataResource = elementData;
            dataSitesResource = elementData.studySiteMeta;
            dataSitesResource.forEach(elementList => {
              if (elementList.siteId == this.piRoleUniqueId) {
                overallListResource.push(dataResource);
              }
            });
          });
          materialOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
          this.newLinksData = materialOrderSequence;
        } else if (this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") {
          let linksData = _.orderBy(response.body, "createdTime", "desc");
          this.newLinksData = linksData.filter(el => {
            return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
          });
        } else {
          materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          this.newLinksData = materialOrderSequence;
        }
      });
      await this.$api.getAllResourcesData(this.studyId, "announcement").then(response => {
        window.localStorage.removeItem("announcementData");
        window.localStorage.setItem("announcementData", JSON.stringify(response.body));
        if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "Interviewer" || this.user.userRole == "CallCenter") {
          let materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          let dataResource = [];
          let dataSitesResource = [];
          let overallListResource = [];
          materialOrderSequence.forEach(elementData => {
            dataResource = elementData;
            dataSitesResource = elementData.studySiteMeta;
            dataSitesResource.forEach(elementList => {
              if (elementList.siteId == this.piRoleUniqueId) {
                overallListResource.push(dataResource);
              }
            });
          });
          materialOrderSequence = _.orderBy(overallListResource, "createdTime", "desc");
          this.newAnnouncementData = materialOrderSequence;
        } else if (this.user.userRole == "Cra" || this.user.userRole == "Dm" || this.user.userRole == "Quality" || this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "StudyManager" || this.user.userRole == "Biostatistics" || this.user.userRole == "Pharmacovigilance" || this.user.userRole == "CraUB") {
          let annData = _.orderBy(response.body, "createdTime", "desc");
          this.newAnnouncementData = annData.filter(el => {
            return el.userRole == "SystemAdmin" || el.userRole == "StudyAdmin";
          });
        } else {
          let materialOrderSequence = _.orderBy(response.body, "createdTime", "desc");
          this.newAnnouncementData = materialOrderSequence;
        }
      });
      await this.gettedmaterialsData.map(el => {
        let datevalue = new Date(el.createdTime);
        let currentDate = new Date();
        let diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
        if (diffDays <= 10) {
          this.materialCount++;
        }
      });
      await this.newLinksData.map(el => {
        let datevalue = new Date(el.createdTime);
        let currentDate = new Date();
        let diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
        if (diffDays <= 10) {
          this.newLinksCount++;
        }
      });
      await this.newAnnouncementData.map(el => {
        let datevalue = new Date(el.createdTime);
        let currentDate = new Date();
        let diffDays = parseInt((currentDate - datevalue) / (1000 * 60 * 60 * 24), 10);
        if (diffDays <= 10) {
          this.newAnnCount++;
        }
      });
      this.newResourceCount = this.materialCount + this.newAnnCount + this.newLinksCount;
      return this.newResourceCount;
    },
    getToggledFeatures() {
      this.toggleFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      this.toggleFeatures.forEach(feature => {
        if (feature.featureKey === "EDC") {
          this.edcEnabled = feature.enabled;
        }
        if (feature.featureKey === "TruClinic") {
          this.telehealthEnabled = feature.enabled;
        }
        if (feature.featureKey === "ANALYTICS_DASHBOARD") {
          this.analyticsEnabled = feature.enabled;
        }

        if (feature.featureKey === "TELEHEALTH") {
          this.isTelehealthV2Enabled = feature.enabled;
        }
      });
    },
    getUserObj() {
      let userObj = localStorageService.getItem("userObj");
      this.selectedSiteId = userObj && userObj.siteIds && userObj.siteIds[0];
      this.userDefineSiteId = userObj && userObj.siteIds && userObj.userSite.find(item => item.siteId == this.selectedSiteId).userDefineSiteId;
    }
  }
};
</script>

<style scoped lang="scss" src="./styles/side-menu.scss" />
